import { useEffect, useState } from 'react';
import { useGetAllQuestionQuery, useGetByIdPreStockInspectionsQuery } from '../../../../../../api';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../../../../../contexts/LanguageContext';

const useQuestionsAnswersData = (inspectionId, isEdit) => {
    const [questionsWithAnswers, setQuestionsWithAnswers] = useState([]);
    const [inspectionInfo, setInspectionInfo] = useState(null);
    const { getCurrentLanguageId } = useLanguage();
    const { data: questionList = [], isLoading: isLoadingQuestions } = useGetAllQuestionQuery({ languageId: getCurrentLanguageId() });
    const { data: inspectionData, isLoading: isLoadingInspection } = useGetByIdPreStockInspectionsQuery(inspectionId, { skip: !inspectionId });

    const initializeCreateMode = () => {
        const emptyAnswers = questionList.map((question) => ({
            questionId: question.id,
            answerId: 0,
            questionText: question.text,
            answer: 1,
            comment: ''
        }));
        setQuestionsWithAnswers(emptyAnswers);
        setInspectionInfo(null);
    };
    const initializeEditMode = () => {
        if (!inspectionData) return;

        const inspection = inspectionData;

        const merged = questionList.map((question) => {
            const matched = inspection?.answers?.find((a) => Number(a.questionId) === Number(question.id));

            return {
                questionId: question.id,
                answerId: matched?.id ?? 0,
                questionText: question.text,
                answer: matched?.answer ?? 1,
                comment: matched?.comment || ''
            };
        });

        setQuestionsWithAnswers(merged);

        setInspectionInfo({
            id: inspection.id,
            inspectorName: inspection.inspectorName,
            inspectorTitle: inspection.inspectorTitle,
            inspectionDate: inspection.inspectionDate,
            stockInDate: inspection.stockInDate,
            vin: inspection.vin,
            notesOrOtherDamages: inspection.notesOrOtherDamages,
            status: inspection.status
        });
    };

    useEffect(() => {
        if (!questionList.length) return;

        if (isEdit) {
            initializeEditMode();
        } else {
            initializeCreateMode();
        }
    }, [questionList, inspectionData, inspectionId]);
    return {
        questionsWithAnswers,
        inspectionInfo,
        isLoading: isLoadingQuestions || isLoadingInspection
    };
};

export default useQuestionsAnswersData;
